import styled from 'styled-components';
export const ChipContainer = styled.div `
  position: relative;
  display: flex;
  outline: none;

  > div:first-child {
    padding: 0 0.5rem 0 0.5rem;
  }

  height: 2.5rem;
  @media ${({ theme }) => theme.device.touch} {
    max-height: 2.75rem;
    min-height: 2.75rem;
  }

  ${({ chipMinWidth, isStrechedWidth }) => isStrechedWidth ? 'flex: 1 0 0%' : `flex: 0 0 ${chipMinWidth}px;`}

  ${({ disabled, selected, type, theme }) => disabled
    ? `
        background-color: rgba(${theme.colors.transparentBlack},0.08);
        color:rgba(${theme.colors.transparentBlack},0.26);
        & svg {fill: rgb(${theme.colors.transparentBlack}, 0.26);}
      `
    : selected && type !== 'A'
        ? `
          background-color: rgba(${theme.colors.transparentBlack},0.26);
          &:hover {
            cursor: pointer;
            background-color: rgba(${theme.colors.transparentBlack},0.36);
          }
        `
        : `
        background-color: rgba(${theme.colors.transparentBlack},0.08);
        &:hover {
          cursor: pointer;
          background-color: rgba(${theme.colors.transparentBlack},0.16);
        }
  `};

  &:focus-visible {
    ${({ disabled, theme }) => !disabled
    ? `outline: 2px solid ${theme.colors.primaryLight}`
    : `outline: 1px solid rgba(${theme.colors.transparentBlack},0)`};
  }

  &:active {
    ${({ disabled, type, selected, theme }) => !disabled
    ? type === 'B'
        ? selected
            ? `
              background-color: rgba(${theme.colors.transparentBlack},0.08);
            `
            : `background-color: rgba(${theme.colors.transparentBlack},0.26); `
        : `
            background-color: ${theme.colors.grey15};
            color: ${theme.colors.white};
            & svg {fill: ${theme.colors.white};}
          `
    : ''}
  }
`;
export const TitleWrapper = styled.div `
  height: 2.5rem;
  ${({ isShowLabel }) => (isShowLabel ? `>p:first-child {padding-right:2px;}` : '')}
  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
  }
  line-height: 1rem;
  display: flex;
  flex: 1;
  align-items: center;
  overflow: hidden;
  & > p {
    margin: 0;
    &:last-child {
      white-space: nowrap;
    }
  }
  & > div {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const IconWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  > span > svg {
    width: 1.25rem;
    height: 1.25rem;
  }

  height: 2.5rem;
  min-width: 2.5rem;
  width: 2.5rem;

  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
    min-width: 2.75rem;
    width: 2.75rem;
  }
`;
